import { createConfig } from "@commonlibs";
import { default as config } from "common/config/config";
import lightTheme from "./theme/lightTheme";
import TableCount from "ui/common/components/display/TableCount/TableCount";
import TablePagination from "ui/common/components/navigation/TablePagination/TablePagination";
import ChevronLeftIcon from "ui/common/icons/ChevronLeftIcon";
import ChevronRightIcon from "ui/common/icons/ChevronRightIcon";
import { spacing } from "./theme/spacing/spacing";

const uiConfig = createConfig({
    ...config,
    themes: {
        default: lightTheme,
    },
    components: {
        Button: {
            defaultProps: {
                variant: "primary",
                size: "lg",
            },
        },
        Divider: {
            defaultProps: {
                color: "overlays.900.8",
            },
        },
        FormControlLabel: {
            defaultProps: {
                gap: spacing[2],
            },
        },
        Label: {
            defaultProps: {
                alignment: "start",
            },
        },
        Paper: {
            defaultProps: {
                elevation: 0,
            },
        },
        PaginatedTable: {
            defaultProps: {
                Count: TableCount,
                Pagination: TablePagination,
                enableSorting: true,
            },
        },
        Pagination: {
            defaultProps: {
                nextIcon: <ChevronRightIcon />,
                previousIcon: <ChevronLeftIcon />,
            },
        },
        Table: {
            defaultProps: {
                enableSorting: false,
            },
        },
        TextInput: {
            defaultProps: {
                errorElement: false,
                validElement: false,
            },
        },
        TextArea: {
            defaultProps: {
                rows: 3,
            },
        },
        BlockchainAddress: {
            blockchainLinks: {
                address: `${config.blockchainLinks.explorer}/address/`,
                tx: `${config.blockchainLinks.explorer}/txns/`,
                receipt: `${config.blockchainLinks.explorer}/txns/`,
            },
        },
        Image: {
            defaultProps: {
                fallback: config.fallbackImages.defaultImage,
            },
        },
    },
});

export default uiConfig;
